import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import t from 'format-message';
import { withStyle, jsx } from '@instructure/emotion';
import { Billboard } from '@instructure/ui-billboard';
import { Flex } from '@instructure/ui-flex';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import { SimpleSelect } from '@instructure/ui-simple-select';
import { View } from '@instructure/ui-view';
import { IconCheckSolid } from '@instructure/ui-icons';
import OutcomeSelectionList from "../OutcomeSelectionList/index.js";
import OutcomeFolderList from "../OutcomeFolderList/index.js";
import TreeBrowser from "./TreeBrowser/index.js";
var AlignOutcomes = function AlignOutcomes(props) {
  return jsx("svg", Object.assign({
    width: "120",
    height: "87",
    viewBox: "0 0 120 87",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("title", null, "Align-Outcomes"), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("path", {
    d: "M77.383 16.062a6.636 6.636 0 0 0 .604-2.762 6.667 6.667 0 0 0-4.204-6.193c.012-.142.022-.286.022-.431a4.958 4.958 0 0 0-4.958-4.958 4.927 4.927 0 0 0-2.898.94A11.87 11.87 0 0 0 59.881 1c-4.753 0-8.856 2.779-10.776 6.8a7.219 7.219 0 0 0-2.983-.648c-4 0-7.243 3.243-7.243 7.243 0 .574.074 1.13.201 1.667h38.303z",
    fill: "#FFF"
  }), jsx("path", {
    d: "M77.383 16.062a6.636 6.636 0 0 0 .604-2.762 6.667 6.667 0 0 0-4.204-6.193c.012-.142.022-.286.022-.431a4.958 4.958 0 0 0-4.958-4.958 4.927 4.927 0 0 0-2.898.94A11.87 11.87 0 0 0 59.881 1c-4.753 0-8.856 2.779-10.776 6.8a7.219 7.219 0 0 0-2.983-.648c-4 0-7.243 3.243-7.243 7.243 0 .574.074 1.13.201 1.667h38.303z",
    stroke: "#CED3D7",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M118.39 23.614c.015-.228.025-.457.025-.688 0-5.703-4.623-10.327-10.326-10.327-1.913 0-3.704.523-5.24 1.43a7.675 7.675 0 0 0-14.68 2.219 6.02 6.02 0 0 0-.936-.08 5.992 5.992 0 0 0-5.992 5.992c0 .502.07.988.185 1.454h36.964z",
    fill: "#FFF"
  }), jsx("path", {
    d: "M118.39 23.614c.015-.228.025-.457.025-.688 0-5.703-4.623-10.327-10.326-10.327-1.913 0-3.704.523-5.24 1.43a7.675 7.675 0 0 0-14.68 2.219 6.02 6.02 0 0 0-.936-.08 5.992 5.992 0 0 0-5.992 5.992c0 .502.07.988.185 1.454h36.964z",
    stroke: "#CED3D7",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M84.402 85.735a3.82 3.82 0 0 1-3.174-1.685L57.064 48.29 32.901 84.05a3.827 3.827 0 1 1-6.34-4.284l30.503-45.148L87.57 79.766a3.827 3.827 0 0 1-3.167 5.97",
    fill: "#E5E8EA"
  }), jsx("path", {
    d: "M84.402 85.735a3.82 3.82 0 0 1-3.174-1.685L57.064 48.29 32.901 84.05a3.827 3.827 0 1 1-6.34-4.284l30.503-45.148L87.57 79.766a3.827 3.827 0 0 1-3.167 5.97z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M84.398 50.201c0 15.096-12.238 27.334-27.334 27.334S29.73 65.297 29.73 50.201s12.238-27.334 27.334-27.334 27.334 12.238 27.334 27.334",
    fill: "#FFF"
  }), jsx("path", {
    d: "M84.398 50.201c0 15.096-12.238 27.334-27.334 27.334S29.73 65.297 29.73 50.201s12.238-27.334 27.334-27.334 27.334 12.238 27.334 27.334z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M77.291 50.201c0 11.171-9.055 20.227-20.226 20.227s-20.227-9.056-20.227-20.227c0-11.17 9.056-20.227 20.227-20.227 11.17 0 20.227 9.056 20.227 20.227",
    fill: "#F1060F"
  }), jsx("path", {
    d: "M77.291 50.201c0 11.171-9.055 20.227-20.226 20.227s-20.227-9.056-20.227-20.227c0-11.17 9.056-20.227 20.227-20.227 11.17 0 20.227 9.056 20.227 20.227z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M70.185 50.201c0 7.246-5.874 13.12-13.12 13.12-7.246 0-13.121-5.874-13.121-13.12 0-7.246 5.875-13.12 13.12-13.12 7.247 0 13.12 5.874 13.12 13.12",
    fill: "#FFF"
  }), jsx("path", {
    d: "M70.185 50.201c0 7.246-5.874 13.12-13.12 13.12-7.246 0-13.121-5.874-13.121-13.12 0-7.246 5.875-13.12 13.12-13.12 7.247 0 13.12 5.874 13.12 13.12z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M63.625 50.201a6.56 6.56 0 1 1-13.12 0 6.56 6.56 0 0 1 13.12 0",
    fill: "#F1060F"
  }), jsx("path", {
    d: "M63.625 50.201a6.56 6.56 0 1 1-13.12 0 6.56 6.56 0 0 1 13.12 0z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M42.855 23.346a8.598 8.598 0 0 0 .857-3.736 8.655 8.655 0 0 0-8.654-8.654c-4.003 0-7.361 2.72-8.35 6.41a8.657 8.657 0 0 0-2.548-.532l.002-.027A8.344 8.344 0 0 0 8.12 13.59C4.074 14.314 1 17.845 1 22.1c0 .424.04.837.1 1.245h41.755z",
    fill: "#FFF"
  }), jsx("path", {
    d: "M42.855 23.346a8.598 8.598 0 0 0 .857-3.736 8.655 8.655 0 0 0-8.654-8.654c-4.003 0-7.361 2.72-8.35 6.41a8.657 8.657 0 0 0-2.548-.532l.002-.027A8.344 8.344 0 0 0 8.12 13.59C4.074 14.314 1 17.845 1 22.1c0 .424.04.837.1 1.245h41.755z",
    stroke: "#CED3D7",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), jsx("path", {
    fill: "#3F5463",
    d: "M64.635 43.022V15.576l10.02 10.021 14.62-14.619 7.404 7.403-14.62 14.62 10.023 10.021z"
  }), jsx("path", {
    d: "M89.275 8.857l-2.12 2.12-12.499 12.499-6.4-6.4-5.122-5.121v32.568h32.568L90.58 39.4l-6.4-6.4 12.498-12.498 2.122-2.121-2.122-2.122-5.282-5.282-2.12-2.121zm0 4.243l5.282 5.282L79.938 33l8.521 8.522H66.134V19.197l8.522 8.522 14.62-14.62z",
    fill: "#FFF"
  })));
};
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { sanitizeHtml } from "../../lib/sanitize.js";
import { selectedLaunchContextShape, launchContextsShape, stylesShape } from "../../store/shapes.js";
var OutcomeTree = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeTree, _React$Component);
  var _super = _createSuper(OutcomeTree);
  function OutcomeTree() {
    _classCallCheck(this, OutcomeTree);
    return _super.apply(this, arguments);
  }
  _createClass(OutcomeTree, [{
    key: "setRHS",
    value: function setRHS(rhs) {
      this.rhs = rhs; // eslint-disable-line immutable/no-mutation
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var oldCollection = oldProps.activeCollection ? oldProps.activeCollection.id : null;
      var newCollection = this.props.activeCollection ? this.props.activeCollection.id : null;
      var parent = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
      if (oldCollection !== newCollection && parent && !parent.contains(document.activeElement) && this.rhs) {
        var next = this.rhs.querySelector('input') || this.rhs.querySelector('button');
        if (next) {
          next.focus();
        }
      }
    }
  }, {
    key: "renderActiveCollection",
    value: function renderActiveCollection() {
      var activeCollection = this.props.activeCollection;
      return activeCollection && activeCollection.id ? jsx("div", {
        css: this.props.styles.selectedOutcomeCollection
      }, jsx("div", null, jsx(Heading, {
        level: "h3",
        as: "h2",
        margin: "0 0 x-small"
      }, activeCollection.header)), jsx("div", null, jsx(Text, {
        size: "x-small"
      }, activeCollection.summary)), jsx(Text, {
        size: "x-small"
      }, jsx("div", {
        css: this.props.styles.outcomeDescription,
        className: "outcomeTreeOutcomeDescription",
        dangerouslySetInnerHTML: {
          // eslint-disable-line react/no-danger
          __html: sanitizeHtml(activeCollection.description)
        }
      }))) : jsx(Billboard, {
        message: t('Browse your outcomes using the group folders.'),
        heading: t('Align Outcomes'),
        headingAs: "h3",
        headingLevel: "h3",
        size: "small",
        hero: jsx(AlignOutcomes, null),
        margin: "medium"
      });
    }
  }, {
    key: "renderContextSelector",
    value: function renderContextSelector() {
      var _this$props = this.props,
        launchContexts = _this$props.launchContexts,
        selectedLaunchContext = _this$props.selectedLaunchContext,
        changeSelectedLaunchContext = _this$props.changeSelectedLaunchContext;
      var hasMoreThanOneContext = (launchContexts === null || launchContexts === void 0 ? void 0 : launchContexts.length) >= 2;
      if (hasMoreThanOneContext) {
        return jsx(View, {
          as: "div",
          padding: "small small none",
          "data-automation": "outcomeTree__outcomesLaunchContextSelector"
        }, jsx(SimpleSelect, {
          renderLabel: t('Source'),
          value: selectedLaunchContext.name,
          onChange: function onChange(e, _ref) {
            var id = _ref.id,
              value = _ref.value;
            return changeSelectedLaunchContext({
              uuid: id,
              name: value
            });
          }
        }, launchContexts.map(function (context) {
          var isSelected = selectedLaunchContext.uuid === context.uuid;
          return isSelected ? jsx(SimpleSelect.Option, {
            id: context.uuid,
            key: context.uuid,
            value: context.name,
            renderBeforeLabel: function renderBeforeLabel(_props) {
              return jsx(IconCheckSolid, null);
            }
          }, context.name) : jsx(SimpleSelect.Option, {
            id: context.uuid,
            key: context.uuid,
            value: context.name
          }, context.name);
        })));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props2 = this.props,
        activeChildren = _this$props2.activeChildren,
        collections = _this$props2.collections,
        setFocusedOutcome = _this$props2.setFocusedOutcome,
        getOutcomeSummary = _this$props2.getOutcomeSummary,
        isOutcomeSelected = _this$props2.isOutcomeSelected,
        selectOutcomeIds = _this$props2.selectOutcomeIds,
        deselectOutcomeIds = _this$props2.deselectOutcomeIds,
        setActiveCollection = _this$props2.setActiveCollection,
        rootOutcomeIds = _this$props2.rootOutcomeIds,
        activeCollection = _this$props2.activeCollection,
        toggleExpandedIds = _this$props2.toggleExpandedIds,
        expandedIds = _this$props2.expandedIds;
      var groups = activeChildren.groups,
        nonGroups = activeChildren.nonGroups;
      return jsx(Flex, {
        alignItems: "stretch",
        height: "100%",
        width: "100%"
      }, jsx(Flex.Item, {
        width: "30%"
      }, jsx("div", {
        css: this.props.styles.outcomeTree,
        "data-automation": "outcomePicker__outcomeTree"
      }, this.renderContextSelector(), jsx(TreeBrowser, {
        collections: collections,
        setActiveCollection: setActiveCollection,
        rootOutcomeIds: rootOutcomeIds,
        expandedIds: expandedIds,
        toggleExpandedIds: toggleExpandedIds
      }))), jsx(Flex.Item, {
        size: "0",
        shouldGrow: true,
        display: "flex",
        borderWidth: "0 0 0 small"
      }, jsx(Flex, {
        height: "100%",
        width: "100%",
        direction: "column",
        alignItems: "stretch",
        css: this.props.styles.outcomeContent,
        elementRef: function elementRef(rhs) {
          return _this.setRHS(rhs);
        },
        "data-automation": "outcomePicker__outcomeContent"
      }, jsx(Flex.Item, {
        size: "0",
        shouldGrow: true
      }, this.renderActiveCollection(), jsx(OutcomeSelectionList, {
        setFocusedOutcome: setFocusedOutcome,
        outcomes: nonGroups,
        isOutcomeSelected: isOutcomeSelected,
        selectOutcomeIds: selectOutcomeIds,
        deselectOutcomeIds: deselectOutcomeIds
      }), jsx(OutcomeFolderList, {
        outcomes: groups,
        setActiveCollection: setActiveCollection,
        getOutcomeSummary: getOutcomeSummary,
        toggleExpandedIds: toggleExpandedIds,
        activeCollectionId: activeCollection ? activeCollection.id : null
      })))));
    }
  }]);
  OutcomeTree.displayName = "OutcomeTree";
  return OutcomeTree;
}(React.Component), _class2.propTypes = {
  expandedIds: PropTypes.array,
  toggleExpandedIds: PropTypes.func.isRequired,
  setFocusedOutcome: PropTypes.func.isRequired,
  getOutcomeSummary: PropTypes.func.isRequired,
  isOutcomeSelected: PropTypes.func.isRequired,
  selectOutcomeIds: PropTypes.func.isRequired,
  launchContexts: launchContextsShape,
  selectedLaunchContext: selectedLaunchContextShape,
  changeSelectedLaunchContext: PropTypes.func.isRequired,
  deselectOutcomeIds: PropTypes.func.isRequired,
  collections: PropTypes.object.isRequired,
  setActiveCollection: PropTypes.func.isRequired,
  rootOutcomeIds: PropTypes.array.isRequired,
  activeChildren: PropTypes.shape({
    groups: PropTypes.array,
    nonGroups: PropTypes.array
  }),
  activeCollection: PropTypes.shape({
    id: PropTypes.string,
    header: PropTypes.string,
    summary: PropTypes.string,
    description: PropTypes.string
  }),
  styles: stylesShape
}, _class2.defaultProps = {
  expandedIds: null,
  activeCollection: null,
  activeChildren: {
    groups: [],
    nonGroups: []
  },
  launchContexts: null,
  selectedLaunchContext: null
}, _class2)) || _class);
export default OutcomeTree;